import { useTranslation } from "react-i18next";
import { WorkOrderManagementButtonsProps } from "../../types/workorderManagementButtonsProps";
import { ActivityType } from "../../types/activityType";
import { useNavigate} from "react-router-dom";

export default function WorkorderManagementBottomButtons(props: WorkOrderManagementButtonsProps) {
    const { t } = useTranslation();
    let navigate = useNavigate();

    return (
        <div
            id="div-bottom-buttons"
            className="row float-right btn-group margin-right-0 buttoms-shift-up"
            role="group"
            aria-label="Bottom action buttons"
        >
            <input
                disabled={!props.options.offlineLabl}
                id="offlinePrint"
                type="button"
                value={t("main.offlinePrint")!}
                className={`btn btn-secondary ${props.options.offlineLabl ? "active" : ""}`}
                onClick={props.options.offlineLablClick}
            />
            <input
                disabled={!props.options.offlineCons}
                id="offlineCons"
                type="button"
                value={t("main.offlineCons")!}
                className={`btn btn-secondary ${props.options.offlineCons ? "active" : ""}`}
                onClick={props.options.offlineConsClick}
            />
            {(props.options.activityType === ActivityType.Labelling || props.options.activityType === ActivityType.Unspecified) && (
                <input
                    disabled={!props.options.assignLabl}
                    id="btnAssignLabelling"
                    type="button"
                    value={t("main.assign")! + " " + t("main.labels")!}
                    className={`btn btn-secondary ${props.options.assignLabl ? "active" : ""}`}
                    onClick={props.options.assignLablClick}
                />
            )}
            {(props.options.activityType === ActivityType.Consumption || props.options.activityType === ActivityType.Unspecified) && (
                <input
                    disabled={!props.options.assignCons}
                    id="btnAssignConsumption"
                    type="button"
                    value={t("main.assign")! + " " + t("main.rxg_Consumption")!}
                    className={`btn btn-secondary ${props.options.assignCons ? "active" : ""}`}
                    onClick={props.options.assignConsClick}
                />
            )}
            <input
                disabled={!props.options.manageWorkorder}
                id="btnManageWorkorder"
                type="button"
                value={t("main.btnWoMan")!}
                className={`btn btn-secondary ${props.options.manageWorkorder ? "active" : ""}`}
                onClick={props.options.manageWorkorderClick}
            />
            <input
                disabled={false}
                id="btnWorkorderBack"
                type="button"
                value={t("main.back")!}
                className={`btn btn-secondary active`}
                onClick={() => navigate(-1)}
            />
        </div>
    );
}
